import { useEffect, useRef, type RefObject } from 'react';

/** A ref that is true while the component is mounted - lets async continuations skip setState/navigate once the
 * user has already left (or the step swapped itself out). */
export function useIsMounted(): RefObject<boolean> {
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted;
}
